// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__32Ntl","label":"CategoryService_label__2T1Ju","location":"CategoryService_location__lLxZn"};